import { render, staticRenderFns } from "./RecebimentoFiltros.vue?vue&type=template&id=83ceb5c6&scoped=true"
import script from "./RecebimentoFiltros.vue?vue&type=script&lang=ts"
export * from "./RecebimentoFiltros.vue?vue&type=script&lang=ts"
import style0 from "./RecebimentoFiltros.vue?vue&type=style&index=0&id=83ceb5c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ceb5c6",
  null
  
)

export default component.exports